import React from 'react';
export var DotsIcon = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, viewBox: "0 0 17 5", width: "17px", height: "5px" },
        React.createElement("g", { stroke: "currentColor", strokeWidth: "1", fill: "none" },
            React.createElement("rect", { x: "0.5", y: "0.5", width: "4", height: "4" }),
            React.createElement("rect", { x: "6.5", y: "0.5", width: "4", height: "4" }),
            React.createElement("rect", { x: "12.5", y: "0.5", width: "4", height: "4" }))));
};
//# sourceMappingURL=DotsIcon.js.map